import { H2RInput } from "../../imports";
import { H2RSelect } from "../../imports";
import { animatedBackgroundDefinitions } from "../../imports";

export const GraphicEditor = ({ cue, onUpdate }) => {
	return (
		<>
			<H2RSelect
				selected={cue.animationName || "gradient_rotate"}
				label="Animation"
				options={[
					{
						label: "Moving gradient",
						value: "moving_gradient",
					},
					{
						label: "Floating bulbs",
						value: "floating_bulbs",
					},
				]}
				onChange={(value) => {
					onUpdate({ animationName: value });
				}}
			/>

			<H2RInput
				label={`Colour 1`}
				value={cue.colour1}
				colourPicker={true}
				onChange={(value) => {
					onUpdate({ colour1: value });
				}}
			/>

			<H2RInput
				label={`Colour 2`}
				value={cue.colour2}
				colourPicker={true}
				onChange={(value) => {
					onUpdate({ colour2: value });
				}}
			/>
		</>
	);
};

export const GraphicCueContent = ({ cue, twoLines }) => {
	return (
		<div
			className={`overflow-ellipsis w-48 md:w-auto max-w-xs md:max-w-sm lg:max-w-lg overflow-hidden
            ${twoLines ? "whitespace-normal max-h-10" : "whitespace-nowrap"}
            `}
		>
			<span className="font-semibold">
				{animatedBackgroundDefinitions?.[cue.animationName]?.name}
			</span>
		</div>
	);
};
